module.exports = __webpack_public_path__ + "media/ya.38a82148.mp3";